import React, { useEffect, useState } from "react";
import "./travelerform.css";
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton";

const emptyRow = {
  first_name: "",
  last_name: "",
  date_of_birth: "",
  country: "",
  passport_number: "",
  tickets: "",
  airline_res_no: "",
};

const TravelerForm = ({travelers,setTravelers,travelersModalClose}) => {
  const [rows, setRows] = useState([emptyRow]);

  useEffect(() => {
    if (travelers?.length > 0) {
      setRows([...travelers])
    }
  },[travelers])

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const addRow = () => {
    setRows([...rows, { 
  first_name: "",
  last_name: "",
  date_of_birth: "",
  country: "",
  passport_number: "",
  tickets: "",
  airline_res_no: "",
}]);
  };

  const deleteRow = (index) => {
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated.length ? updated : [emptyRow]);
  };




 const handleSubmit = () => {
  const formatted = rows
    .filter((row) => {
      return (
        row.first_name?.trim() &&
        row.last_name?.trim() &&
        row.date_of_birth &&
        row.country?.trim()
      );
    })
    .map((item) => {
  const subClaimData = {
    first_name: item.first_name.trim(),
    last_name: item.last_name.trim(),
    date_of_birth: item.date_of_birth,
    country: item.country.trim(),
    passport_number: item.passport_number?.trim() || "",
    tickets: item.tickets?.trim() || "",
    airline_res_no: item.airline_res_no?.trim() || "",
  };

  // ✅ only attach id if exists
  if (item.id) {
    subClaimData.id = item.id;
  }

  return subClaimData;
});

  // Optional: prevent empty submit
   if (formatted.length === 0) {
     toast.error("Please fill at least one valid traveler");
    
    return;
  }

   setTravelers(formatted);
   travelersModalClose()

};
  return (
    <div className="traveler-container">
      <h2>Traveler Details</h2>

      <div className="table-wrapper">
        <table className="excel-table">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>DOB</th>
              <th>Nationality</th>
              <th>Passport Number</th>
              <th>E - ticket Number</th>
              <th>Airline Reservation Number</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    value={row.first_name}
                    onChange={(e) =>
                      handleChange(index, "first_name", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    value={row.last_name}
                    onChange={(e) =>
                      handleChange(index, "last_name", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    type="date"
                    value={row.date_of_birth}
                    onChange={(e) =>
                      handleChange(index, "date_of_birth", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    value={row.country}
                    onChange={(e) =>
                      handleChange(index, "country", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    value={row.passport_number}
                    onChange={(e) =>
                      handleChange(index, "passport_number", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    value={row.tickets}
                    onChange={(e) =>
                      handleChange(index, "tickets", e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    value={row.airline_res_no}
                    onChange={(e) =>
                      handleChange(index, "airline_res_no", e.target.value)
                    }
                  />
                </td>

                <td style={{textAlign:'center'}}>
                  <button
                    className="delete-btn"
                    onClick={() => deleteRow(index)}
                  >
                    <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10 12V17" stroke="#ff1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 12V17" stroke="#ff1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4 7H20" stroke="#ff1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="#ff1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#ff1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="actions">
        <CustomButton type="secondary" btnText={'Add Row'} onClick={addRow}/>
        <CustomButton btnText={' Save & Close'} onClick={handleSubmit}/>
       

       
      </div>
    </div>
  );
};

export default TravelerForm;